import {
    decrementPage,
    incrementPage,
    resetPageSize,
    setPage,
    setPageSize,
} from '../reducers';

import {visibilityStateSelector} from '../selectors';
import {
    useAppDispatch,
    useAppSelector
} from '../../../hooks/useTypedReactRedux';

export const usePersonasPaging = () => {

    const dispatch = useAppDispatch();

    // FNP-950: page size and page number are genuine Redux UI state. The
    // totalPages the old selector returned was derived from a records slice
    // nothing populated, and no caller rendered it - these tables use token
    // pagination + infinite scroll, not page numbers. It is gone rather than
    // recomputed.
    const {
        limit,
        page,
    } = useAppSelector((state) => visibilityStateSelector(state));


    // PAGING
    const handlePageChange = (page: number) => {
        dispatch(setPage(page));
    };

    const handleIncrementPage = () => {
        dispatch(incrementPage());
    };

    const handleDecrementPage = () => {
        dispatch(decrementPage());
    };

    const handleItemsPerPageChange = (pageSize: string | null) => {
        dispatch(setPageSize(pageSize));
    };

    const handleResetPageSize = () => {
        dispatch(resetPageSize());
    };

    return {
        limit,
        page,
        handlePageChange,
        handleIncrementPage,
        handleDecrementPage,
        handleItemsPerPageChange,
        handleResetPageSize,
    };
};
